import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Skeleton, Button, Tag, Drawer, Space } from 'antd';
import { NodePlusFill, TicketPerforatedFill, EyeFill, GeoAltFill, CaretRight } from 'react-bootstrap-icons';
import moment from "moment";
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EventView = function EventView(_ref) {
  var event = _ref.event,
    handleNewTicket = _ref.handleNewTicket,
    handeDisplayDetails = _ref.handeDisplayDetails;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "white-bg feed-box",
      children: [/*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            sm: 5,
            xs: 5,
            children: /*#__PURE__*/_jsx("img", {
              src: event.image_file,
              style: {
                width: '100%'
              }
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 8,
            md: 8,
            sm: 7,
            xs: 7,
            children: [/*#__PURE__*/_jsx("h6", {
              children: /*#__PURE__*/_jsx("b", {
                children: event.label
              })
            }), /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsxs(Space, {
                style: {
                  marginBottom: "10px"
                },
                direction: "horizontal",
                wrap: true,
                children: [/*#__PURE__*/_jsx(Tag, {
                  color: "#DBCB85",
                  children: event.event_category.label
                }), /*#__PURE__*/_jsxs(Tag, {
                  color: "#694D36",
                  children: [/*#__PURE__*/_jsx(GeoAltFill, {
                    size: 17
                  }), " ", event.place]
                })]
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    fontSize: "17px",
                    fontWeight: "bold",
                    padding: "10px",
                    borderRadius: "4px",
                    color: "#FFFFFF",
                    background: "#EB9800"
                  },
                  children: new Date(event.starts_at).getDay()
                }), /*#__PURE__*/_jsxs("h5", {
                  children: [new Date(event.starts_at).toLocaleDateString('Fr', {
                    month: 'long'
                  }), " ", new Date(event.starts_at).getFullYear()]
                })]
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                style: {
                  clear: "both"
                },
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  disabled: moment(event.starts_at) < moment() || Common.currentUser == 'undefined' && Common.currentUser.role != 901,
                  onClick: function onClick() {
                    handleNewTicket(event);
                  },
                  icon: /*#__PURE__*/_jsx(TicketPerforatedFill, {}),
                  children: /*#__PURE__*/_jsx("b", {
                    children: " R\xE9server"
                  })
                }), /*#__PURE__*/_jsxs(Button, {
                  type: "link",
                  onClick: function onClick() {
                    handeDisplayDetails(event);
                  },
                  children: [" ", /*#__PURE__*/_jsx("b", {
                    children: "VOIR"
                  })]
                })]
              })]
            }), /*#__PURE__*/_jsx("br", {})]
          })]
        })
      }), /*#__PURE__*/_jsx("br", {})]
    })
  });
};
export default EventView;